import { AxiosInstance } from 'axios';
import { IUserTokens, updateTokens } from '../../storage/user';

const toLoginPost = (refreshToken: string) => {
  return [
    `refresh_token=${encodeURIComponent(refreshToken)}`,
    `grant_Type=refresh_token`,
  ].join('&');
};

const fromLoginPost = (response: any): IUserTokens => {
  return {
    token: response.access_token,
    refreshToken: response.refresh_token,
  };
};

export default (api: AxiosInstance, url: string) => async (
  refreshToken: string
) => {
  try {
    const response = await api.post(url, toLoginPost(refreshToken));
    const tokens = fromLoginPost(response.data);
    updateTokens(tokens);
    return tokens;
  } catch ({ message }) {
    console.warn(message);
    return;
  }
};



// WEBPACK FOOTER //
// ./src/services/api/user/refreshToken.ts